export enum UserRolesTypes {
    ALL = 'all',
    OWNER = 'owner',
    SUPER_USER = 'isSuperUser',
    PROVISIONED = 'isUserProvisioned',
    CLOUD_GUARD_MANAGED = 'isUsersManagedInCloudGuard',
    ONBOARDING_PERMITTED = 'isOnboardingPermitted',
}
